exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content .quiz-text[data-v-2b9994cc] {\n  text-align: center;\n  color: white;\n  margin-top: 17px;\n  font-size: 20px;\n  line-height: 24px;\n}\n@media screen and (min-height: 669px) {\n.content .quiz-text[data-v-2b9994cc] {\n    font-size: 24px;\n    line-height: 29px;\n}\n}\n.content .quiz-image[data-v-2b9994cc] {\n  border-radius: 7px;\n  margin: 0 auto;\n  display: block;\n}\n@media screen and (max-height: 569px) {\n.content .quiz-image[data-v-2b9994cc] {\n    width: 270px;\n}\n}", ""]);

// exports
